import React from 'react';
import { HStack } from 'native-base';
import { Tooltip } from 'antd';
import { useDispatch } from 'react-redux';
import AppText from '../../../../../../../common/AppText';
import CustomButtonV2 from '../../../../../../../common/CustomButtonV2';
import IconsGenerator from '../../../../../../../Icons8Generator/IconsGenerator';
import InfoTooltip from '../../../../../../../common/InfoTooltip';
import { GlobalConsts } from '../../../../../../../../styles/GlobalConsts';
import { Colors } from '../../../../../../../../styles/Colors';
import { t } from '../../../../../../../../services/i18n';
import { openLimitedPackageModal } from '../../../../../../../../services/Helpers';
import usePermissions from '../../../../../../../../services/Permissions';

const ConnectButton = ({ onConnect, disabled, disableReason }) => {
    const dispatch = useDispatch();
    const { hasLock } = usePermissions();

    return (
        <CustomButtonV2
            onClick={!disabled ? onConnect : null}
            override={({ color }) => (
                <Tooltip title={disableReason}>
                    <HStack
                        opacity={disabled ? '50%' : '100%'}
                        justifyContent={'space-between'}
                        style={{ border: 'solid 1px ' + Colors.newDesign.avatarBgColor, borderRadius: '4px' }}
                        padding={'15px'}
                        width={'100%'}
                    >
                        <HStack alignItems={'center'} space={'1rem'}>
                            <IconsGenerator size={GlobalConsts.iconSize.M} name={'googleCalendar'} />
                            <AppText color={!disabled && color}>{t('connect-to-your-google-account')}</AppText>
                        </HStack>
                        {hasLock('calendarSync') && (
                            <CustomButtonV2
                                onClick={() => openLimitedPackageModal(dispatch)}
                                iconName={'fa-lock-keyhole'}
                                type={'link'}
                            />
                        )}
                    </HStack>
                </Tooltip>
            )}
        />
    );
};

export default ConnectButton;
